export default "__VITE_ASSET__C$4Pm1zX__"